import { Card, Col, Row } from 'antd';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { type ColorBlockSpecsFragment } from '../../../../api/fragments/ColorBlockSpecs';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';
import TrimBlockSettingField from './TrimBlockSettingField';

type TrimBlockFormProps = {
    colorBlock: ColorBlockSpecsFragment;
    disabled?: boolean;
};

const TrimBlockForm = ({ colorBlock, disabled = false }: TrimBlockFormProps) => {
    const { t } = useTranslation(['variantConfiguratorDetails']);
    const { yesNoSwitch } = useSystemSwitchData();

    const [field] = useField<boolean>('trimBlockInput.isActive');

    return (
        <>
            <Card>
                <Row gutter={14}>
                    <Col lg={12} xs={24}>
                        <FormFields.TranslatedInputField
                            {...t('variantConfiguratorDetails:fields.trims.sectionTitle', { returnObjects: true })}
                            disabled={disabled}
                            name="trimBlockInput.sectionTitle"
                            required
                        />
                    </Col>
                    <Col lg={12} xs={24}>
                        <FormFields.SwitchField
                            {...yesNoSwitch}
                            {...t('variantConfiguratorDetails:fields.trims.isActive', { returnObjects: true })}
                            disabled={disabled}
                            name="trimBlockInput.isActive"
                        />
                    </Col>
                </Row>
            </Card>
            {field.value && (
                <TrimBlockSettingField colorBlock={colorBlock} disabled={disabled} name="trimBlockInput.trimSettings" />
            )}
        </>
    );
};

export default TrimBlockForm;
